const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const Index = () => import(/* webpackChunkName: "unit" */'@/components/pages/unit/Index.vue');

export default [
  {
    path: '/unit',
    component: Layout,
    meta: {
      roles: ['UNIT_QUERY'],
    },
    children: [{
      path: '',
      name: 'unit',
      component: Index,
      meta: {
        roles: [],
        title: '单位信息',
        icon: 'unit',
        activeMenu: '/unit',
        componentName: 'unit',
        breadcrumb: [
          {
            name: '首页',
            path: '/home'
          },
          {
            name: '单位信息',
            path: '/unit'
          }
        ]
      }
    }]
  }
];



// WEBPACK FOOTER //
// ./src/router/unit.js